import React from "react";
import OrPromoteWidget from "../../../components/OrPromoteWidget";

export default function PromoteWidget(props) {
  return <OrPromoteWidget {...props} />;
}
